import { useEffect, useState } from "react";
import Image from "../Image";
import YouTube from "react-youtube";
//styling
import styles from "./index.module.css";

const ImgPreview = ({ event }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [lastsImages, setLastsImages] = useState([]);

  const pushImage = (image) => {
    setLastsImages([...lastsImages, image]);
  };

  const isAlreadyLoad = (image) => {
    return Boolean(lastsImages.find((i) => i == image));
  };

  useEffect(() => {
    setError(null);

    if (!event) return;
    if (event.x && event.y) {
      if (!isAlreadyLoad(event.img) && !event.video) {
        setIsLoaded(false);
        pushImage(event.img);
      } else {
        setIsLoaded(true);
      }

      setHeight(100);
      setTimeout(() => {
        setIsOpen(true);
      }, 300);
    }
  }, [event]);

  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setHeight(0);
      }, 300);
    } else {
      setHeight(100);
    }
  }, [isOpen]);

  return (
    <div className={styles.previewContainer} style={{ height: height + "vh" }}>
      <div
        style={{
          transformOrigin: `${event ? event.x : 0}px ${event ? event.y : 0}px`,
          transform: `scale(${isOpen ? 1 : 0})`,
        }}
        className={styles.previewAnimation}
      >
        <div
          className={styles.controlsContainer}
          onClick={() => setIsOpen(false)}
        >
          <div
            className={
              styles.imgContainer + (!isLoaded ? " " + styles.loading : "")
            }
          >
            {error ? (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  justifyContent: "center",
                  color: "rgba(255,255,255,0.5)",
                  fontSize: "20px",
                }}
              >
                <span>{error}</span>
              </div>
            ) : (
              <>
                {event ? (
                  <>
                    {event.video ? (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                        }}
                      >
                        <YouTube videoId={event.video} />
                      </span>
                    ) : (
                      <span
                        style={{
                          opacity: isLoaded ? 1 : 0,
                          transition: "ease-in-out 0.2s",
                        }}
                      >
                        <Image
                          src={event.img}
                          alt="preview"
                          onLoad={() => setIsLoaded(true)}
                          onError={(e) =>
                            setError("Impossible de charger l'image !")
                          }
                        />
                      </span>
                    )}
                  </>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImgPreview;
